export default __webpack_public_path__ + "static/candid-b96f9d25b29353d0b5c35737599e278e.svg";